module.exports = __webpack_public_path__ + "640772fc0395471f2f739368574e0f6d.jpg";